<template>
    <img :src="svgDataUrl" :width="width" :height="height" :alt="alt" />
</template>

<script>
export default {
    props: {
        width: {
            type: [Number, String],
            default: 285,
        },
        height: {
            type: [Number, String],
            default: 164,
        },
        alt: {
            type: String,
            default: 'Image placeholder',
        },
        useGradient: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        svgDataUrl() {
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${this.width}" height="${this.height}" viewBox="0 0 285 164" fill="none">
        <rect width="285" height="164" fill="url(#paint0_linear_1_215)"/>
        <defs>
        <linearGradient id="paint0_linear_1_215" x1="427.5" y1="82" x2="285.708" y2="-164.407" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D9E7BF"/>
        <stop offset="0.5" stop-color="#C9E0E7"/>
        <stop offset="1" stop-color="#E8BFBA"/>
        </linearGradient>
        </defs>
      </svg>`

            return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
        },
    },
}
</script>
